import ApiService from "@/services/ApiService";
import { serialize } from "@/utils/helper";
export default {
  newPost(data) {
    return ApiService().post("/posts", data, true, "multipart/form-data");
  },
  updatePost(data) {
    return ApiService().post("/posts/update", data, true, "multipart/form-data");
  },
  deletePost(key) {
    return ApiService().delete(`/posts/${key}`);
  },
  getPostList(data) {
    const param = serialize(data);
    return ApiService().get(`/posts?${param}`, false, true);
  },
  getPostListLanguage(data) {
    const param = serialize(data);
    return ApiService().get(`/posts/languages?${param}`);
  },
  setLike(data) {
    return ApiService().post("/likes", data, true);
  },
  setUnLike(data) {
    return ApiService().delete(`/likes/${data.entityName}/${data.entityId}`);
  },
  getPostListSubscriptions(data) {
    const param = serialize(data);
    return ApiService().get(`/posts/my-subscription?${param}`, false, true);
  },
  report(data) {
    return ApiService().post(`/report`, data);
  },
  getPostDetail(payload){
    const param = serialize(payload);
    return ApiService().get(`/posts?${param}`);
  },
  getHashtags(param){
    let data = '?sort_desc=counter';
    if(param) data = data + param;
    return ApiService().get(`/tags${data}`);
  },
  getDiscussions(payload){
    const param = serialize(payload);
    return ApiService().get(`/posts?${param}`);
  },
};
